/**
 * PDP Mobile Click Handler
 * Adds click event listeners to images and videos in the mobile slider
 * Only active on screens below 1024px
 * Triggers alert when user clicks on media elements
 */

document.addEventListener('DOMContentLoaded', function() {
  'use strict';

  // Maximum screen width for this functionality to be active
  const MAX_SCREEN_WIDTH = 1023;

  // Define the selectors for media elements in mobile slider
  // Target .splide__slide to avoid interfering with Splide swipe/drag
  const mediaSelectors = [
    // Target the slide elements in the main mobile slider
    '.pdp-mobile-image-slider .splide__slide'
  ];

  // Data attribute to mark elements that already have handlers
  const HANDLER_ATTACHED_ATTR = 'data-mobile-click-handler-attached';

  /**
   * Check if screen width is below maximum (mobile only)
   */
  function isScreenWidthValid() {
    return window.innerWidth <= MAX_SCREEN_WIDTH;
  }

  /**
   * Initialize click handlers for all mobile slider media elements
   */
  function initMobileClickHandlers() {
    // Only run on screens below 1024px
    if (!isScreenWidthValid()) {
      console.log('Screen width above 1023px, skipping mobile click handlers');
      return;
    }

    // Combine all selectors and query all matching elements
    const allMediaElements = document.querySelectorAll(mediaSelectors.join(', '));

    console.log(`[Mobile] Found ${allMediaElements.length} media elements to attach click handlers`);

    // Add click event listener to each media element
    allMediaElements.forEach(function(mediaElement) {
      // Skip if handler already attached
      if (mediaElement.hasAttribute(HANDLER_ATTACHED_ATTR)) {
        return;
      }

      // Mark as having handler attached
      mediaElement.setAttribute(HANDLER_ATTACHED_ATTR, 'true');
      mediaElement.style.cursor = 'pointer'; // Make it obvious it's clickable

      mediaElement.addEventListener('click', function(event) {
        console.log('[Mobile Click] Slide clicked');

        // Don't trigger if this was a drag/swipe action
        // Splide sets a data attribute during drag
        const splideTrack = mediaElement.closest('.splide__track');
        if (splideTrack && splideTrack.classList.contains('is-dragging')) {
          console.log('[Mobile Click] Drag detected, ignoring click');
          return;
        }

        // Trigger mobile gallery popup
        if (typeof window.openMobileGallery === 'function') {
          console.log('[Mobile Click] Triggering openMobileGallery');
          window.openMobileGallery();
        } else {
          console.warn('[Mobile Click] openMobileGallery function not found');
        }
      });
    });
  }

  /**
   * Re-initialize handlers after dynamic content loads (e.g., Splide slider)
   * This function can be called after Splide initialization
   */
  function reinitHandlers() {
    initMobileClickHandlers();
  }

  // Wait for Splide slider initialization
  // Check if Splide instance exists and is mounted
  function waitForSplide() {
    const sliderElement = document.querySelector('.pdp-mobile-image-slider');
    if (!sliderElement) {
      console.log('[Mobile] No mobile slider found');
      // Try once anyway in case slider loads later
      initMobileClickHandlers();
      return;
    }

    // Check if Splide is already initialized
    if (sliderElement.classList.contains('is-initialized')) {
      console.log('[Mobile] Splide already initialized, attaching click handlers');
      initMobileClickHandlers();
      return;
    }

    // Wait for Splide to initialize
    const checkInterval = setInterval(function() {
      // Check if Splide is mounted by looking for splide classes
      if (sliderElement.classList.contains('is-initialized')) {
        clearInterval(checkInterval);
        console.log('[Mobile] Splide initialized, attaching click handlers');
        setTimeout(initMobileClickHandlers, 100);
      }
    }, 100);

    // Timeout after 5 seconds
    setTimeout(function() {
      clearInterval(checkInterval);
      console.log('[Mobile] Timeout waiting for Splide, attaching handlers anyway');
      initMobileClickHandlers(); // Try anyway
    }, 5000);
  }

  // Initial setup on DOMContentLoaded (current event)
  waitForSplide();

  // Also try on window load as fallback
  window.addEventListener('load', function() {
    setTimeout(waitForSplide, 100);
  });

  // Expose reinit function globally for manual triggering if needed
  window.pdpMobileClickHandler = {
    reinit: reinitHandlers
  };
});
